import AuditService from './AuditService'

let instance

export default function AuditServiceProvider () {
  if (!instance) {
    instance = new AuditService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/audit/AuditServiceProvider.js